import request from './request.js'
export default {
	// 查询rsa加密公钥
	getRSAPublicKey(params) {
		return request({
			url: '/Cryptography/GetRSAPublicKey',
			method: 'get',
		});
	},
}
